module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec.external && (_vm.value && _vm.spec.link)) ? _c('router-link', {
    staticClass: "form-control-static",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.schemaTitle) + "\n")]) : (_vm.spec.external && (_vm.value && typeof _vm.spec.schema.view === 'function')) ? _c('a', {
    staticClass: "form-control-static",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.view
    }
  }, [_vm._v(_vm._s(_vm.schemaTitle) + "\n")]) : (_vm.spec.external) ? _c('p', {
    staticClass: "form-control-static",
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.nil'))
    }
  }) : (_vm._readonly && !_vm.value) ? _c('p', {
    staticClass: "form-control-static",
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.nil'))
    }
  }) : _c('el-collapse', {
    attrs: {
      "value": _vm.spec.expand ? 'a' : null
    }
  }, [_c('el-collapse-item', {
    staticClass: "sub-schema",
    class: _vm.panelClass,
    attrs: {
      "name": "a"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.schemaTitle) + "\n      "), (_vm.value && _vm.spec.link) ? _c('router-link', {
    staticStyle: {
      "display": "block",
      "float": "right",
      "padding": "0 15px"
    },
    attrs: {
      "to": _vm.link
    }
  }, [_c('i', {
    staticClass: "ti-new-window"
  })]) : (_vm.value && typeof _vm.spec.schema.view === 'function') ? _c('a', {
    staticStyle: {
      "display": "block",
      "float": "right",
      "padding": "0 15px"
    },
    attrs: {
      "target": "_blank",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.view($event)
      }
    }
  }, [_c('i', {
    staticClass: "ti-new-window"
  })]) : _vm._e()], 1), _vm._v(" "), _c('schema-form', {
    ref: "form",
    attrs: {
      "schema": _vm.spec.schema,
      "model": _vm.value,
      "$parentForm": this,
      "rootModel": _vm.rootModel,
      "$rootForm": _vm.$rootForm,
      "readonly": _vm._readonly,
      "showActions": _vm.spec.showActions,
      "embedded": true
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51e9d032!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-schema.vue
// module id = 522
// module chunks = 55